import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import { Transactions } from "./Transactions";

export function ShowLatestTransactionRequests({ user, filteredEmployee }) {
  return (
    <div className="EmployeeInfo">
      <div className="EmployeeList">
        <div className="Header">
          <div className="titleContainer row">
            <StickyNote2Icon style={{ padding: "0 10px 0 0" }} />
            <h3>My Latest Transaction Requests</h3>
          </div>
        </div>
        <div className="employeeTabs">
          <Transactions user={user} filteredEmployee={filteredEmployee} />
        </div>
      </div>
    </div>
  );
}